export const getInitialStateIndicators = () => ({
    indicatorsPt: [
        {
            "key": "draft",
            "value": 0
        },
        {
            "key": "approval_esg",
            "value": 0
        },
        {
            "key": "evaluation_avesso",
            "value": 0
        },
        {
            "key": "evaluation_suzano",
            "value": 0
        },
        {
            "key": "finished",
            "value": 0
        }
    ],
    indicatorsEn: [
        {
            "key": "draft_en",
            "value": 0
        },
        {
            "key": "evaluation_suzano_en",
            "value": 0
        },
        {
            "key": "finished_en",
            "value": 0
        }
    ],
});